import { ACTION_TYPES } from "../../../Constants";
import _ from "lodash";

const isTokenValid = () => {
  const expiration = localStorage.getItem("tokenExpiration");
  return expiration && Date.now() < parseInt(expiration, 10);
};

const initialState = {
  isAuthenticated: isTokenValid(),
  token: localStorage.getItem("token") || null,
  menuToggle: false,
  userid:localStorage.getItem("userid") || "",
  userType: localStorage.getItem("userType") || "",
  subCmpny: localStorage.getItem("subcompany") || ""
};

const getAuthToken = (payload) =>
  payload?.accessToken ||
  payload?.token ||
  payload?.tokens?.accessToken ||
  payload?.auth?.accessToken;

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.AUTH: {
      const payload = action?.payload || {};
      const resolvedToken = getAuthToken(payload);
      const user = payload?.user || {};

      if (!_.isEmpty(resolvedToken)) {
        localStorage.setItem("isAuthenticated", true);
        localStorage.setItem("token", resolvedToken);
        localStorage.setItem("tokenExpiration", Date.now() + 1 * 24 * 60 * 60 * 1000);
        localStorage.setItem("userid", user?.id || payload?.id || "");
        localStorage.setItem("userType", user?.userType || payload?.userType || "");
        if (payload?.sub_companyName) {
          localStorage.setItem("subcompany", payload.sub_companyName);
        } else {
          localStorage.removeItem("subcompany");
        }
      }
      const tokenExpiration = parseInt(localStorage.getItem("tokenExpiration"), 10);
      const tokenIsValid = tokenExpiration && Date.now() < tokenExpiration;

      return {
        ...state,
        isAuthenticated: !_.isEmpty(resolvedToken) && tokenIsValid ? true : false,
        token: resolvedToken || localStorage.getItem("token") || null,
        userid: localStorage.getItem("userid") || "",
        userType: localStorage.getItem("userType") || "",
        subCmpny: localStorage.getItem("subcompany") || ""
      };
    }
    case ACTION_TYPES.MENU_TOGGLE: {
      return {
        ...state,
        menuToggle: action.payload,
      };
    }
    default:
      return state;
  }
};

export default AuthReducer;
